import {
  ON_REPORTS_SELECT_CUSTOM_EVENTS_CLICKED,
  ON_REPORTS_SELECT_CUSTOM_EVENTS_CLOSED,
  ON_REPORTS_SELECT_CUSTOM_EVENT_TOGGLED,
  ON_REPORTS_SELECT_ALL_EVENTS,
  ON_REPORTS_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED,
  ON_REPORTS_SELECTED_CURRENCY_CHANGE,
  ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE,
  ON_REPORTS_SHOW_ALL_EVENTS_CLICKED,
  UPDATE_STATE_WITH_FETCHED_REPORT,
} from '../actions';

const initialState = {
  isOpen: false,
  selected: [], // <-- list of ids
  events: {} // <-- hash of events by ID => { eventIdOne: { id: 'eventIdOne', title: 'MyEvent' ... } }
};

export default (state = initialState, action) => {
  switch (action.type){
    default:
      return state;

    case UPDATE_STATE_WITH_FETCHED_REPORT:{
      return { ...state, selected: action.payload.fetchedReport.events };
    }

    case ON_REPORTS_SHOW_ALL_EVENTS_CLICKED:{
      return initialState;
      break;
    }

    case ON_REPORTS_SELECT_CUSTOM_EVENTS_CLICKED:{
      return { ...state, isOpen: true };
      break;
    }

    case ON_REPORTS_SELECT_CUSTOM_EVENTS_CLOSED:
    case ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE:{
      return { ...state, isOpen: false };
    }

    case ON_REPORTS_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED:{
      let newEvents = {};
      let newSelected = state.selected;

      if (action.meta.addToState) {
        // no dupes - using a set for simplicity
        const setOfIDs = new Set(newSelected);
        action.payload.ids.forEach(id => setOfIDs.add(id));
        newSelected = [...setOfIDs];

        // merge our old events with the new one, removes dupes :+1:
        newEvents = { ...state.events, ...action.payload.events };
      }
      else {
        newSelected = newSelected.filter(eventId => action.payload.ids.indexOf(eventId) === -1);

        const idsToRemove = Object.keys(action.payload.events);
        const newEventIds = Object.keys(state.events).filter(eventId => idsToRemove.indexOf(eventId) === -1);
        newEvents  = newEventIds.reduce((events, id) => {
          events[id] = state.events[id];
          return events;
        }, {});
      }

      return {
        ...state,
        selected: newSelected,
        events: newEvents
      };
    }

    case ON_REPORTS_SELECT_CUSTOM_EVENT_TOGGLED:{
      let newEvents = null;
      let newSelected = state.selected;
      const idxToRemove = state.selected.indexOf(action.payload.id);

      // remove the id from our list, and remove the event from our hash
      if (idxToRemove !== -1) {
        newSelected = state.selected.filter((e, idx) => idx !== idxToRemove);
        const newEventIds = Object.keys(state.events).filter(eventId => eventId !== action.payload.event.id);
        newEvents = newEventIds.reduce((events, id) => {
          events[id] = state.events[id];
          return events;
        }, {});
      }
      else {
        // add the id to our list, and add the event to our hash
        newSelected = state.selected.concat(action.payload.id);
        newEvents = Object.assign({}, state.events, {
          [action.payload.event.id]: action.payload.event
        });
      }

      return {
        ...state,
        selected: newSelected,
        events: newEvents
      };
    }

    case ON_REPORTS_SELECT_ALL_EVENTS:{
      return {
        ...state,
        selected: [],
        events: {},
      };
    }

    case ON_REPORTS_SELECTED_CURRENCY_CHANGE:{
      return {
        ...state,
        selected: [],
        events: {}
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/selected-events-modal.js